import { getInstanceDefinition } from '../cards/cardLookup';
import { getPlayerCollectionInstanceIds } from '../state/selectors';

// VP from every card across a player's entire personal collection (hand + deck
// + discard + familiar, all zones at once) - rulebook, "Scoring".
export function computePlayerScore(state, playerId) {
  const allInstanceIds = getPlayerCollectionInstanceIds(state, playerId);
  return allInstanceIds.reduce((sum, instanceId) => sum + (getInstanceDefinition(state, instanceId).points || 0), 0);
}

// Winner = highest total VP. Tie-break 1: whoever defeated the Thunderstone
// Bearer (only applicable if it was defeated, not if it escaped). Tie-break 2:
// most unspent XP.
export function computeFinalScores(state) {
  const scores = state.players.map((p) => ({
    playerId: p.id,
    points: computePlayerScore(state, p.id),
    xp: p.xp,
  }));

  // Into the Abyss, Heart of Doom: "the active player loses" (Matt's own
  // ruling: true elimination) ends the game immediately once only one
  // player remains, and that player wins outright regardless of VP -
  // cards/effectHelpers.js's eliminatePlayer already set meta.winnerId at
  // the moment this happened, so this is authoritative, not a tiebreak.
  if (state.meta.endTrigger === 'eliminated' && state.meta.winnerId) {
    return { scores, winnerId: state.meta.winnerId, tied: false };
  }

  // An eliminated player (in a game that later ends via a different
  // trigger, with 2+ players still standing) keeps their own score entry
  // above for display, but is never eligible to WIN via the VP tiebreak
  // below - they already lost.
  const eligible = scores.filter((s) => !state.players.find((p) => p.id === s.playerId).eliminated);
  const maxPoints = Math.max(...eligible.map((s) => s.points));
  let contenders = eligible.filter((s) => s.points === maxPoints);

  if (contenders.length > 1 && state.meta.endTrigger === 'defeated' && state.meta.winnerId) {
    const bearerSlayer = contenders.find((s) => s.playerId === state.meta.winnerId);
    if (bearerSlayer) contenders = [bearerSlayer];
  }
  if (contenders.length > 1) {
    const maxXp = Math.max(...contenders.map((s) => s.xp));
    contenders = contenders.filter((s) => s.xp === maxXp);
  }

  return { scores, winnerId: contenders[0].playerId, tied: contenders.length > 1 };
}
